import type { HitResultItem } from 'vue-instantsearch/vue3/es';
import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';
import type { ProductAttributes } from '~~/types/product/attribute/ProductAttributes';
import { PRODUCT_ATTRIBUTES } from '~~/constants/products';
import {
  getProductAttributesExtended,
} from '~~/helpers/product/getProductAttributesExtended';
import type { ProductLocalisedAttributes } from '~~/types/product/attribute/ProductLocalisedAttributes';
import type { EnergyRatingDetails } from '~~/types/components/EnergyRating/EnergyRatingDetails';

type GetByProductParams = {
  product: ProductVariantExtended;
  languageAndCountry: string;
  localisedAttributes?: never;
  item?: never;
};

type GetByAttributesParams = {
  product?: never;
  languageAndCountry?: never;
  localisedAttributes: ProductLocalisedAttributes;
  item?: never;
};

type GetByTypesenseItemParams = {
  product?: never;
  languageAndCountry?: never;
  localisedAttributes?: never;
  item: HitResultItem;
};

type EnergyRatingParams = GetByProductParams | GetByAttributesParams | GetByTypesenseItemParams;

export const getEnergyRating = (params: EnergyRatingParams): EnergyRatingDetails | null => {

  const { product, localisedAttributes, item, languageAndCountry } = params;

  const getAttributeValue = (
    attributeKey: ProductAttributes,
    localisedAttributeKey?: keyof ProductLocalisedAttributes,
  ) => {

    if (product) {

      return getProductAttributesExtended(
        product,
        {
          attributeNames: [attributeKey],
          languageAndCountry,
        })[attributeKey];
    
    } else if (localisedAttributes && localisedAttributeKey && localisedAttributeKey in localisedAttributes) {

      return localisedAttributes[localisedAttributeKey];
    
    } else if (item) {

      if (attributeKey === PRODUCT_ATTRIBUTES.ENERGY_RATING_CLASS) {

        return item.energyRating;
      
      }

      return item[attributeKey];
    
    }
  
  };

  const labelUrl = getAttributeValue(PRODUCT_ATTRIBUTES.ENERGY_RATING_LABEL);
  const productCardUrl =
    getAttributeValue(PRODUCT_ATTRIBUTES.ENERGY_RATING_FICHE,
      PRODUCT_ATTRIBUTES.ENERGY_RATING_FICHE as keyof ProductLocalisedAttributes);
  const ratingIconUrl = getAttributeValue(PRODUCT_ATTRIBUTES.ENERGY_RATING_NESTED_LABEL);
  const ratingClassString = getAttributeValue(PRODUCT_ATTRIBUTES.ENERGY_RATING_CLASS);

  if (!labelUrl || !productCardUrl || !ratingIconUrl) {

    return null;
  
  }

  return {
    labelUrl,
    productCardUrl,
    ratingIconUrl,
    ratingClassString,
  };

};
